import { render, staticRenderFns } from "./CopyPartModal.vue?vue&type=template&id=3a5293a7&scoped=true"
import script from "./CopyPartModal.vue?vue&type=script&lang=js"
export * from "./CopyPartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5293a7",
  null
  
)

export default component.exports